import * as tslib_1 from "tslib";
import datapoints from '../datapoints';
import AttachmentMenuEntrySource from '../types/AttachmentMenuEntrySource';
import createAttachmentHandler from '../utils/createAttachmentHandler';
import focusToEditor from '../utils/focusToEditor';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import { PerformanceDatapoint } from 'owa-analytics';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import { attachmentMultiMenuEntry } from 'owa-attachment-multi-menu-actions';
import { FilterableCommandBar } from 'owa-filterable-menu';
import { FilterableMenuItem } from 'owa-filterable-menu';
import { lazyMoveComposeToPopout } from 'owa-mail-compose-store';
import clickAttachButton from 'owa-mail-compose-store/lib/actions/clickAttachButton';
import discardCompose from 'owa-mail-compose-store/lib/actions/discardCompose';
import floatCompose from 'owa-mail-compose-store/lib/actions/floatCompose';
import protectMessage from 'owa-mail-compose-store/lib/actions/protectMessage';
import setAsyncSendState from 'owa-mail-compose-store/lib/actions/setAsyncSendState';
import setImportance from 'owa-mail-compose-store/lib/actions/setImportance';
import setIsDirty from 'owa-mail-compose-store/lib/actions/setIsDirty';
import switchBodytype from 'owa-mail-compose-store/lib/actions/switchBodytype';
import toggleFrom from 'owa-mail-compose-store/lib/actions/toggleFrom';
import trySaveMessage from 'owa-mail-compose-store/lib/actions/trySaveMessage';
import trySendMessage from 'owa-mail-compose-store/lib/actions/trySendMessage';
import { findComposePlugins } from 'owa-mail-compose-store/lib/plugins/ComposePlugins';
import { getStore } from 'owa-mail-compose-store/lib/store/composeStore';
import isEncryptionFeatureEnabled from 'owa-mail-compose-store/lib/utils/isEncryptionFeatureEnabled';
import shouldDisableEncryptionButton from 'owa-mail-compose-store/lib/utils/shouldDisableEncryptionButton';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import { AttachmentLocalComputerFilePicker, FilePickerAction, FileSelectionFilter, } from 'owa-attachment-filepicker-view';
import { ENCRYPT_GUID, ENCRYPT_DNF_GUID, } from 'owa-mail-compose-store/lib/store/schema/EncryptionGUID';
var styles = require('./ComposeCommandingBar.scss');
var ComposeCommandingBar = /** @class */ (function (_super) {
    tslib_1.__extends(ComposeCommandingBar, _super);
    function ComposeCommandingBar(props) {
        var _this = _super.call(this, props) || this;
        _this.openFilePicker = function () {
            var composeViewState = _this.props.composeViewState;
            var composePlugins = findComposePlugins(composeViewState);
            var inlineImagePlugin = composePlugins.inlineImagePlugin;
            // The inlineImagePlugin may be null if the editor has already been disposed
            if (inlineImagePlugin) {
                clickAttachButton(false, function (files, shouldShare, isInline) {
                    return createAttachmentHandler(files, inlineImagePlugin, composeViewState, shouldShare, isInline);
                }, composeViewState);
            }
        };
        _this.onSetImportance = function (importance) {
            var composeViewState = _this.props.composeViewState;
            setImportance(composeViewState, importance);
            focusToEditor(composeViewState);
        };
        _this.openAccChecker = function () {
            var composeViewState = _this.props.composeViewState;
            var composePlugins = findComposePlugins(composeViewState);
            var accCheckerPlugin = composePlugins.accCheckerPlugin;
            // The accCheckerPlugin may be null if the editor has already been disposed
            if (accCheckerPlugin) {
                if (accCheckerPlugin.isImported() && composeViewState.accChecker.isOpen) {
                    accCheckerPlugin.getPlugin().then(function (plugin) { return plugin.closeChecker(); });
                }
                else {
                    accCheckerPlugin.addOnImportedCallback(function (plugin) { return plugin.openChecker(); });
                    accCheckerPlugin.getPlugin();
                }
            }
        };
        return _this;
    }
    ComposeCommandingBar.prototype.render = function () {
        var _this = this;
        return (React.createElement("span", null,
            React.createElement(AttachmentLocalComputerFilePicker, { ref: function (ref) { return (_this.attachmentLocalComputerFilePicker = ref); }, fileSelectionFilter: FileSelectionFilter.None, action: FilePickerAction.Attach, createAttachmentHandler: attachmentMultiMenuEntry.computer.getCreateAttachmentHandler(this.props.composeViewState.attachmentWell, function (files, shouldShare, isInline) {
                    var composePlugins = findComposePlugins(_this.props.composeViewState);
                    createAttachmentHandler(files, composePlugins.inlineImagePlugin, _this.props.composeViewState, shouldShare, isInline);
                }) }),
            React.createElement(FilterableCommandBar, { style: this.props.style, className: this.props.className, filterableItems: this.commandingBarItems, elipisisAriaLabel: strings.composeEllipsisAriaLabelText })));
    };
    Object.defineProperty(ComposeCommandingBar.prototype, "commandingBarItems", {
        get: function () {
            var composeViewState = this.props.composeViewState;
            if (composeViewState.asyncSendState == 4 /* Sent */) {
                return [this.closeMenuItem];
            }
            else if (this.props.composeViewState.isSending) {
                return [this.sendingMenuItem, this.minimizeMenuItem];
            }
            else {
                var barItems = [
                    this.sendMenuItem,
                    this.attachMenuItem,
                    this.protectMenuItem,
                    this.discardMenuItem,
                    this.saveDraftMenuItem,
                    this.insertSignatureMenuItem,
                    this.showFromMenuItem,
                    this.setImportanceMenuItem,
                    this.switchBodyType,
                    this.openAccCheckerMenuItem,
                    this.openInPopoutMenuItem,
                ];
                return barItems;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComposeCommandingBar.prototype, "sendingMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.sending, null, null, function () { return true; } /*shouldShow*/, 0 /* Left */, false /*disabled*/, null, null, function () {
                return (React.createElement("span", null,
                    React.createElement(Spinner, { className: styles.topSpinner }),
                    React.createElement("div", { className: styles.topSpinnerText }, strings.sending)));
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComposeCommandingBar.prototype, "minimizeMenuItem", {
        get: function () {
            var _this = this;
            var composeViewState = this.props.composeViewState;
            return new FilterableMenuItem(null, "ChromeMinimize" /* ChromeMinimize */, function () {
                floatCompose(composeViewState, 1 /* Minimized */);
            }, function () {
                return (_this.props.isFloatingCompose &&
                    composeViewState.asyncSendState == 3 /* Timeout */);
            }, 1 /* Right */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComposeCommandingBar.prototype, "closeMenuItem", {
        get: function () {
            var _this = this;
            var composeViewState = this.props.composeViewState;
            return new FilterableMenuItem(null, "ChromeClose" /* ChromeClose */, function () {
                setAsyncSendState(composeViewState, 5 /* Closed */);
            }, function () { return _this.props.isFloatingCompose; }, 1 /* Right */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComposeCommandingBar.prototype, "sendMenuItem", {
        get: function () {
            var _this = this;
            return new FilterableMenuItem(strings.composeSendButton, "Send" /* Send */, function () {
                trySendMessage(_this.props.composeViewState);
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComposeCommandingBar.prototype, "attachMenuItem", {
        get: function () {
            var _this = this;
            if (isAttachmentFeatureEnabled('doc-attachment-dualEntryPoint') ||
                isAttachmentFeatureEnabled('doc-attachment-dualEntryPointNewControl')) {
                var computerMenu = new FilterableMenuItem(attachmentMultiMenuEntry.computer.text(), null, function () {
                    attachmentMultiMenuEntry.computer.logUsage(AttachmentMenuEntrySource.CommandingBar);
                    _this.attachmentLocalComputerFilePicker.getInnerComponent().click();
                });
                computerMenu.iconProps = attachmentMultiMenuEntry.computer.iconProps;
                var onlineLocationMenu = new FilterableMenuItem(attachmentMultiMenuEntry.onlineLocation.text(), null, function () {
                    attachmentMultiMenuEntry.onlineLocation.logUsage(AttachmentMenuEntrySource.CommandingBar);
                    _this.openFilePicker();
                });
                onlineLocationMenu.iconProps = attachmentMultiMenuEntry.onlineLocation.iconProps;
                return new FilterableMenuItem(strings.attachTooltip, "Attach" /* Attach */, null, function () { return true; }, null, false, // disabled
                [computerMenu, onlineLocationMenu]);
            }
            else {
                return new FilterableMenuItem(strings.attachTooltip, "Attach" /* Attach */, this.openFilePicker);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComposeCommandingBar.prototype, "protectMenuItem", {
        get: function () {
            var _this = this;
            var storeState = getStore();
            var encryptMenu = new FilterableMenuItem(strings.encryptMenuText, null /*icon*/, function () {
                protectMessage(_this.props.composeViewState, storeState.complianceConfigurations, ENCRYPT_GUID);
            }, function () { return true; }, null /*displayOption*/, shouldDisableEncryptionButton(this.props.composeViewState, ENCRYPT_GUID));
            var dnfMenu = new FilterableMenuItem(strings.encryptDisableForwardingMenuText, null /*icon*/, function () {
                protectMessage(_this.props.composeViewState, storeState.complianceConfigurations, ENCRYPT_DNF_GUID);
            }, function () { return true; }, null /*displayOption*/, shouldDisableEncryptionButton(this.props.composeViewState, ENCRYPT_DNF_GUID));
            return new FilterableMenuItem(strings.composeProtectButton, "Encryption" /* Encryption */, null /*onClick()*/, function () {
                return isEncryptionFeatureEnabled();
            }, null /*displayOption*/, shouldDisableEncryptionButton(this.props.composeViewState), [encryptMenu, dnfMenu]);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComposeCommandingBar.prototype, "discardMenuItem", {
        get: function () {
            var _this = this;
            return new FilterableMenuItem(strings.composeDiscardButton, null, // no icon
            function () {
                discardCompose(_this.props.composeViewState);
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComposeCommandingBar.prototype, "saveDraftMenuItem", {
        get: function () {
            var _this = this;
            return new FilterableMenuItem(strings.saveDraft, null, // no icon
            function () {
                trySaveMessage(_this.props.composeViewState);
                focusToEditor(_this.props.composeViewState);
            }, function () {
                return true;
            }, 2 /* Overflow */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComposeCommandingBar.prototype, "openInPopoutMenuItem", {
        get: function () {
            var _this = this;
            return new FilterableMenuItem(null, // no string
            "OpenInNewWindow" /* OpenInNewWindow */, function () {
                lazyMoveComposeToPopout.importAndExecute(_this.props.composeViewState);
            }, function () {
                return isMailFeatureEnabled('rp-popouts') && !_this.props.composeViewState.isPopout;
            }, 1 /* Right */, null /* disabled */, null /* menuContent */, null /* key */, null /* onRender */, null /* checked */, strings.popoutsOpenInNewWindow, strings.popoutsOpenInNewWindow);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComposeCommandingBar.prototype, "insertSignatureMenuItem", {
        get: function () {
            var _this = this;
            return new FilterableMenuItem(strings.insertSignature, null, // no icon
            function () {
                var datapoint = new PerformanceDatapoint(datapoints.ComposeCommandInsertSignature.datapoint.name);
                var composePlugins = findComposePlugins(_this.props.composeViewState);
                composePlugins.contentOperationPlugin.insertSignature(_this.props.composeViewState.bodyType);
                setIsDirty(_this.props.composeViewState);
                datapoint.end();
            }, function () {
                return true;
            }, 2 /* Overflow */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComposeCommandingBar.prototype, "showFromMenuItem", {
        get: function () {
            var _this = this;
            return new FilterableMenuItem(!this.props.composeViewState.fromViewState.isFromShown
                ? strings.showFrom
                : strings.hideFrom, null, // no icon
            function () {
                toggleFrom(_this.props.composeViewState);
                focusToEditor(_this.props.composeViewState);
            }, function () {
                return true;
            }, 2 /* Overflow */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComposeCommandingBar.prototype, "setImportanceMenuItem", {
        get: function () {
            var _this = this;
            return new FilterableMenuItem(strings.setImportance, null, // no icon
            null, function () {
                return true;
            }, 2 /* Overflow */, false, // disabled
            [
                new FilterableMenuItem(strings.highImportanceMenuText, null, // no icon
                function () {
                    _this.onSetImportance('High');
                }),
                new FilterableMenuItem(strings.normalImportanceMenuText, null, // no icon
                function () {
                    _this.onSetImportance('Normal');
                }),
                new FilterableMenuItem(strings.lowImportanceMenuText, null, // no icon
                function () {
                    _this.onSetImportance('Low');
                }),
            ]);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComposeCommandingBar.prototype, "switchBodyType", {
        get: function () {
            var composeViewState = this.props.composeViewState;
            var isPlainText = composeViewState.bodyType != 'HTML';
            return new FilterableMenuItem(isPlainText ? strings.switchToHTMLMenuItem : strings.switchToPlainTextMenuItem, null, // no icon
            function () { return switchBodytype(composeViewState); }, function () { return true; }, // shouldShow
            2 /* Overflow */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComposeCommandingBar.prototype, "openAccCheckerMenuItem", {
        get: function () {
            var composeViewState = this.props.composeViewState;
            var isPlainText = composeViewState.bodyType != 'HTML';
            return new FilterableMenuItem(strings.accCheckerMenuItemText, null, // no icon
            this.openAccChecker, function () {
                return isMailFeatureEnabled('cmp-accChecker');
            }, 2 /* Overflow */, isPlainText, // isDisabled
            null, // menuContent
            null, // key
            null, // onRender
            composeViewState.accChecker.isOpen, // isChecked
            null, // ariaLabel
            null, // title
            null, // className
            true // canCheck
            );
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        computed
    ], ComposeCommandingBar.prototype, "sendingMenuItem", null);
    tslib_1.__decorate([
        computed
    ], ComposeCommandingBar.prototype, "minimizeMenuItem", null);
    tslib_1.__decorate([
        computed
    ], ComposeCommandingBar.prototype, "closeMenuItem", null);
    tslib_1.__decorate([
        computed
    ], ComposeCommandingBar.prototype, "sendMenuItem", null);
    tslib_1.__decorate([
        computed
    ], ComposeCommandingBar.prototype, "attachMenuItem", null);
    tslib_1.__decorate([
        computed
    ], ComposeCommandingBar.prototype, "protectMenuItem", null);
    tslib_1.__decorate([
        computed
    ], ComposeCommandingBar.prototype, "discardMenuItem", null);
    tslib_1.__decorate([
        computed
    ], ComposeCommandingBar.prototype, "saveDraftMenuItem", null);
    tslib_1.__decorate([
        computed
    ], ComposeCommandingBar.prototype, "openInPopoutMenuItem", null);
    tslib_1.__decorate([
        computed
    ], ComposeCommandingBar.prototype, "insertSignatureMenuItem", null);
    tslib_1.__decorate([
        computed
    ], ComposeCommandingBar.prototype, "showFromMenuItem", null);
    tslib_1.__decorate([
        computed
    ], ComposeCommandingBar.prototype, "setImportanceMenuItem", null);
    tslib_1.__decorate([
        computed
    ], ComposeCommandingBar.prototype, "switchBodyType", null);
    tslib_1.__decorate([
        computed
    ], ComposeCommandingBar.prototype, "openAccCheckerMenuItem", null);
    ComposeCommandingBar = tslib_1.__decorate([
        observer
    ], ComposeCommandingBar);
    return ComposeCommandingBar;
}(React.Component));
export default ComposeCommandingBar;
//# sourceMappingURL=ComposeCommandingBar.js.map